<template>
  <div class="Contact absolute w-full h-screen flex flex-wrap items-end flex-row-reverse">
    <h1 class="text-transparent fixed">Architect Serving Launceston and Devonport</h1>
    <div v-if="this.showLoading" class="loading w-full h-full fixed bg-white opacity-75">

    </div>
    <div class="w-full md:w-1/2 md:h-full p-6 md:p-24 flex items-end">
      <ContactForm v-if="!messageSent&&!messageFailed" @onSubmit="sendMessage" />
      <div v-if="messageSent" class="w-full bg-primary p-12">
        <h3 class="text-center">Message Sent!</h3>
      </div>
      <div v-if="messageFailed" class="w-full bg-primary p-12">
        <h3 class="text-center text-red-500">Message Failed!</h3>
      </div>
    </div>
    <div class="w-full md:w-1/2 h-full bg-black">
      <gmap-map
        class="relative z-10 w-full h-full bg-black"
        :center="center"
        :zoom="15"
        :options="mapOptions"
      >
        <gmap-marker
          :position="marker.position"
          :icon="{ url: '/img/icons/map_icon.png' }"
        ></gmap-marker>
      </gmap-map>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import ContactForm from '@/components/ContactForm.vue'

export default {
  name: 'contact',
  components: {
    ContactForm
  },
  metaInfo () {
    return {
      title: 'Architecture in Devonport & Launceston | Starbox Architecture',
      meta: [
        {
          name: 'description',
          content: 'Starbox Architecture is a team of Devonport-based architects that serve individuals around Launceston. Visit us online to get started!'
        },
        {
          name: 'keywords',
          content: 'starbox,architecture,starbox architecture,tasmania,tasmanian,tasmanian architecture,tasmania architecture'
        }
      ]
    }
  },
  data () {
    return {
      showLoading: false,
      messageSent: false,
      messageFailed: false,
      marker: {
        position: {
          lat: -41.1809903,
          lng: 146.3609794
        }
      },
      center: { lat: -41.1809903, lng: 146.3609794 },
      mapOptions: {
        gestureHandling: 'cooperative',
        disableDefaultUI: true,
        styles:
        [
          {
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#ffffff'
              }
            ]
          },
          {
            'elementType': 'labels.icon',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          },
          {
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#757575'
              }
            ]
          },
          {
            'elementType': 'labels.text.stroke',
            'stylers': [
              {
                'color': '#212121'
              }
            ]
          },
          {
            'featureType': 'administrative',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#757575'
              }
            ]
          },
          {
            'featureType': 'administrative.country',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#9e9e9e'
              }
            ]
          },
          {
            'featureType': 'administrative.land_parcel',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          },
          {
            'featureType': 'administrative.locality',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#ffffff'
              }
            ]
          },
          {
            'featureType': 'landscape',
            'stylers': [
              {
                'color': '#c9c9c9'
              }
            ]
          },
          {
            'featureType': 'poi',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#757575'
              }
            ]
          },
          {
            'featureType': 'poi.park',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#7a7a7a'
              }
            ]
          },
          {
            'featureType': 'poi.park',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#616161'
              }
            ]
          },
          {
            'featureType': 'poi.park',
            'elementType': 'labels.text.stroke',
            'stylers': [
              {
                'color': '#1b1b1b'
              }
            ]
          },
          {
            'featureType': 'road',
            'elementType': 'geometry.fill',
            'stylers': [
              {
                'color': '#ffffff'
              }
            ]
          },
          {
            'featureType': 'road',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#8a8a8a'
              }
            ]
          },
          {
            'featureType': 'road.arterial',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#ffffff'
              }
            ]
          },
          {
            'featureType': 'road.highway',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#a7a6a7'
              }
            ]
          },
          {
            'featureType': 'road.highway.controlled_access',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#4e4e4e'
              }
            ]
          },
          {
            'featureType': 'road.local',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#ffffff'
              }
            ]
          },
          {
            'featureType': 'transit',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#757575'
              }
            ]
          },
          {
            'featureType': 'water',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#ffffff'
              }
            ]
          },
          {
            'featureType': 'water',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#3d3d3d'
              }
            ]
          }
        ]
      }
    }
  },
  methods: {
    sendMessage (obj) {
      this.showLoading = true

      const updater = new URLSearchParams()
      updater.append('name', obj.name)
      updater.append('email', obj.email)
      updater.append('phone', obj.phone)
      updater.append('message', obj.message)

      axios.post(process.env.VUE_APP_ROOT_API + '/submit_contact', updater).then(response => {
        this.showLoading = false
        // this.$store.dispatch('setShowLoading', false)
        if (response.data === 'SUCCESS') this.messageSent = true
        else this.messageFailed = true
      }).catch(error => {
        this.showLoading = false
        // this.$store.dispatch('setShowLoading', false)
        console.log('Error 1', error)
      })
    }
  }
}
</script>

<style lang="scss">
  .Contact {
    .loading {
      animation: pulseLoading 1s infinite;
    }

    @keyframes pulseLoading {
      0% {
        background-color: rgb(255, 255, 255, 0.7);
      }
      50% {
        background-color: rgb(255, 255, 255, 0.5);
      }
      100% {
        background-color: rgb(255, 255, 255, 0.7);
      }
    }
  }

  // without this the map doens't render outside of local
  .vue-map {
    width: 100% !important;
    height: 100% !important;
  }
</style>
